import tw from 'twin.macro';
import 'styled-components/macro';

const DarkOverlay = tw.div`absolute bg-blue-darkest flex flex-col inset-0 items-stretch z-overlay`;

export default DarkOverlay;
